import { IOrderFlexibleColumns } from '../../../../components/reusable/Table/types';
import { TFunction } from 'i18next';

export enum TABLE_COLUMNS_IDS {
  NAME = 'name',
  NAME_KEY = 'nameKey',
  UNIT = 'unit',
  TYPE = 'type',
  UNIT_KEY = 'unitKey',
  PRIORITY_ORDER = 'priorityOrder',
  DEFAULT = 'default',
  ACTIVE = 'active',
  ACTIONS = 'ACTIONS',
}

const defaultOrderBy = TABLE_COLUMNS_IDS.PRIORITY_ORDER;

function _getTableColumns(t: TFunction): IOrderFlexibleColumns[] {
  return [
    {
      id: TABLE_COLUMNS_IDS.NAME,
      label: t('common.name'),
      key: TABLE_COLUMNS_IDS.NAME,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.NAME,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.NAME_KEY,
      label: t('common.nameKey'),
      key: TABLE_COLUMNS_IDS.NAME_KEY,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.NAME_KEY,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.UNIT,
      label: t('common.unit'),
      key: TABLE_COLUMNS_IDS.UNIT,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.UNIT,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.UNIT_KEY,
      label: t('common.unitKey'),
      key: TABLE_COLUMNS_IDS.UNIT_KEY,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.UNIT_KEY,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.TYPE,
      label: t('common.type'),
      key: TABLE_COLUMNS_IDS.TYPE,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.TYPE,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.PRIORITY_ORDER,
      label: t('common.order'),
      key: TABLE_COLUMNS_IDS.PRIORITY_ORDER,
      type: 'number',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.PRIORITY_ORDER,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.DEFAULT,
      label: t('common.default'),
      key: TABLE_COLUMNS_IDS.DEFAULT,
      type: 'boolean',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.DEFAULT,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.ACTIVE,
      label: t('common.active'),
      key: TABLE_COLUMNS_IDS.ACTIVE,
      type: 'boolean',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.ACTIVE,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.ACTIONS,
      key: TABLE_COLUMNS_IDS.ACTIONS,
      type: 'string',
      sortable: false,
      sortingKey: TABLE_COLUMNS_IDS.ACTIONS,
      align: 'left',
      hided: false,
      isFixed: true,
      canHide: false,
    },
  ];
}

const getTableColumns = (t: TFunction) => _getTableColumns(t);

const hidedColumns: string[] = [];

export const getDefaultSettings = (t: TFunction) => ({
  columnsOrderIds: Object.keys(_getTableColumns(t)).filter(
    (columnId) => !hidedColumns.includes(columnId),
  ),
  orderBy: defaultOrderBy,
  order: 'asc',
  hidedColumns,
});

export default getTableColumns;
